module.exports = __webpack_public_path__ + "img/emerson-balbin.8a754a6d.jpg";